import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { SearchInsuranceModel, AddInsuranceModel, getSubscriberDetails, AddSubscriberResponse, SerchInsuranceResponceModel, UpdateInsuranceModel, UpdateSubscriberInfo, PatienT_INSURANCE_INFO, OcrResponce, DeleteInsuranceModel } from 'src/app/models/insurance/inurance';
import { InsurancePhase2Service } from 'src/app/services/insuranceservicephase2/insurance-phase2.service';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { getPatientDataByURl } from 'src/app/models/verifypatient/verifypatient';

var objectCopyInsurance: any;
declare var $: any;

@Component({
  selector: 'app-patientinsurance',
  templateUrl: './patientinsurance.component.html',
  styleUrls: ['./patientinsurance.component.css']
})
export class PatientinsuranceComponent implements OnInit {
  subSAction: any = "Add";
  searchinsurancemodel: SearchInsuranceModel;
  insurancemodel: boolean = false;
  //CityandStateRequest: CityandStateRequest;
  _addpatientinsurancemodel: AddInsuranceModel;
  getSubscriberDetails: getSubscriberDetails;
  _guarantor: AddSubscriberResponse;
  searchinsuranceresponce: SerchInsuranceResponceModel;
  UpdateInsuranceModel: UpdateInsuranceModel;
  patientpersonalinfo: any;
  _updatesubscriberinfo: UpdateSubscriberInfo;
  _firstNameReq: boolean = false;
  _lastNameReq: boolean = false;
  addressReq: boolean = false;
  zipReq: boolean = false;
  zipLengthReq: boolean = false;
  subcriberReq: boolean = false;
  saveButtonCheck: boolean = false;
  _cityandstateList: any;
  isZipCodeNotValidSuubscriberInfo: boolean = false;
  _insurances: PatienT_INSURANCE_INFO[] = [];
  filterInsuranceSearch: any
  isInsuranceData: boolean = true;
  searchInsuranceFC = new FormControl();
  isLoading: boolean = false;
  insuranceNameError: boolean = false;
  isShowSubscriberForm: boolean = false;
  insurancecat: string = "P";
  displayInsuranceName: string = '';
  maxDate: any;
  insurancetype: any = "Add";
  OcrResponce = new OcrResponce();
  isPopup: boolean = false;
  defaultImagefront: any;
  defaultImageback: any;
  PracticeCode: any;
  PatientAccount: any;
  //for insurances filter
  /*
   As per changes from Adeel Sarwar 
   12/23/2023
   Asad Iftikhar + Syed Zaidi as per video call requirement from Adeel Sarwar
   Before SelectedState was all changed it to list ==> ProviderList as per syed zaidi requirements.
   */

  selectedState: any = 'list';
  Insurancefilter: any = ['all', 'state', 'list']
  HideVerifyDetail: boolean = false;
  isPrimaryInsuranceInactive: boolean = false;
  addInsurance: boolean;
  isFrontPhotoUpload: boolean = false;
  isbackPhotoUpload: boolean = false;
  InsuranceDetails: boolean;
  appointmentId: any;
  isPrimaryInsurancealredyExist: boolean = false;
  insuranceStatus: any = '';
  pcpStatus: any = '';
  notificationCount: any = 0;
  showNotificationIcon: boolean = false;
  landFromCheckin: any;
  newPatientPersonalInfo: getPatientDataByURl;
  isDrsite: boolean = false;
  isDrsiteIntake: boolean = false;

  @ViewChild('scrollCaptureInsurance', { static: false }) private myScrollContainer: ElementRef;
  @ViewChild('fileBack') fileBackInput!: ElementRef;
  constructor(private translateService: TranslateService, private _insuranceservice: InsurancePhase2Service, private _phrutilService: PhrutillsService, private UpdateinfoService: UpdateinfoService,
    private spinner: NgxSpinnerService, private datepipe: DatePipe, private phrUtils: PhrutillsService, private router: Router, private _InsuranceService: InsuranceService) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this.router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.landFromCheckin = localStorage.getItem("landFrom");
    console.log("land from " + this.landFromCheckin);
    if (this.landFromCheckin == 'drsite') {
      this.isDrsite = true;
      this.isDrsiteIntake = false;
    } else if (this.landFromCheckin == 'drsiteintake') {
      this.isDrsiteIntake = true;
      this.isDrsite = false;
    }
    if (this.landFromCheckin == 'drsiteintake' || this.landFromCheckin == 'drsite' || this.landFromCheckin == 'new_patient') {
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
    }
    else {

      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      this.PracticeCode = this.patientpersonalinfo.practice_Code;
      this.PatientAccount = this.patientpersonalinfo.patient_Account;
    }
    this.searchinsurancemodel = new SearchInsuranceModel();
    this._addpatientinsurancemodel = new AddInsuranceModel();
    this.searchinsuranceresponce = new SerchInsuranceResponceModel();
    this.UpdateInsuranceModel = new UpdateInsuranceModel();
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this._guarantor = new AddSubscriberResponse();
    //this.CityandStateRequest = new CityandStateRequest();
    this.getSubscriberDetails = new getSubscriberDetails();
    this.defaultImagefront = 'assets/images/card-front.png';
    this.defaultImageback = 'assets/images/card-back.png';
    let pagesorder = localStorage.getItem('pagesorder');
  }

  ngOnInit(): void {
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
    this.GetPatientInsuranceInfo(this.PatientAccount, this.PracticeCode, this.appointmentId);
    this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.loadScript("../../../assets/js/patientinsurance.js");
    this.translateService.get('button.add').subscribe((translation: string) => {
      this.insurancetype = translation;
    });
    this.translateService.get('button.add').subscribe((translation: string) => {
      this.subSAction = translation;
    });
    if (this.isDrsiteIntake = true) {
      this._phrutilService.patientlanguage$.subscribe(language => {
        //  console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Reservar una cita');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
        } else if (language === 'ur') {
          this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
        } else if (language === 'gu') {
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
        }
        else {
          this._phrutilService.setTitle('Book an Appointment');
        }
      });
    } else {
      this._phrutilService.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Registro de pacientes');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('रोगी पंजीकरण');
        } else if (language === 'ur') {
          this._phrutilService.setTitle('مریض کی رجسٹریشن');
        }
        else {
          this._phrutilService.setTitle('Patient Registration');
        }
      });
    }
  }
  dNoneInsurance: boolean = true;
  insuranceNamePopup: any;
  insuranceNamemain: any;
  Check_record: boolean = false;

  loadScript(scriptUrl: string) {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    document.body.appendChild(scriptElement);
  }
  insName_Id: string = '';
  PatientInsuranceSearch(str: any, type: any) {
    this.insName_Id = '';
    // if (str.keyCode == 8) {
    if (!str.target.value || str.target.value.length < 3) {
      this.isLoading = false;
      this.Check_record = false;
      this.filterInsuranceSearch = [];
      this.isInsuranceData = false;
      this.dNoneInsurance = true;
      this.insuranceNameError = false;
      return false;
    }
    this.Check_record = true;
    this.dNoneInsurance = false;
    // }
    this.searchinsurancemodel.patientAccount = this.PatientAccount;
    this.searchinsurancemodel.practiceCode = this.PracticeCode;
    this.searchinsurancemodel.groupName = "";
    this.searchinsurancemodel.zip = "";
    this.searchinsurancemodel.pageIndex = "1";
    this.searchinsurancemodel.pageSize = "20";
    this.searchinsurancemodel.patientState = this.patientpersonalinfo.STATE ? this.patientpersonalinfo.STATE : '';
    this.searchinsurancemodel.flag = "";
    this.searchinsurancemodel.callFrom = this.selectedState;
    this.searchinsurancemodel.providerCode = "";
    this.searchinsurancemodel.insuranceName = str.target.value;
    if (type == 'main') {
      this.insuranceNamemain = str.target.value;
    }
    else {
      this.insuranceNamePopup = str.target.value;
    }

    if (str) {
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        return false;
      }
      this.isLoading = true;
      //this.spinner.show();
      this._insuranceservice.SearchPatientInsurance(this.searchinsurancemodel).subscribe((res: any) => {
        //this.spinner.hide();
        this.isInsuranceData = true;
        this.isLoading = false;
        if (res) {
          if (res.statusCode == 200) {
            this.filterInsuranceSearch = res.data;
            this.filterInsuranceSearch.map((res1: any) => {
              res1.insurancE_ZIP = this._phrutilService.maskingZipNum(res1.insurancE_ZIP);
            })
            objectCopyInsurance = this.filterInsuranceSearch;
          }
        }
      },
        (error: any) => {
          //this.spinner.hide();
          this.isInsuranceData = true;
          this.isLoading = false;
          this.filterInsuranceSearch = [];
          //this._phrutilService.showError("Service is not available, please try later.");
        })
    }
    return true;
  }
  insuranceDescriptionOCR: any = "";
  isShowField: boolean = false;
  SetInsuranceSearch($event: any, type: any) {

    if ($event) {
      var all = objectCopyInsurance.filter((x: any) => x.inspayeR_DESCRIPTION.toLowerCase() == $event.toLowerCase());
      if (all != undefined && all != null && all.length > 0) {
        this.searchinsuranceresponce = all[0];
        this.insName_Id = this.searchinsuranceresponce.insName_Id;
        this._addpatientinsurancemodel.groupName = this.searchinsuranceresponce.grouP_NAME;
        this._addpatientinsurancemodel.groupId = this.searchinsuranceresponce.grouP_ID;
        this._addpatientinsurancemodel.insuranceId = this.searchinsuranceresponce.insurancE_ID;
        this.UpdateInsuranceModel.insuranceId = this.searchinsuranceresponce.insurancE_ID;
        this.searchinsurancemodel.insuranceName = $event;
        this.insuranceDescriptionOCR = $event;
        this.isShowField = true;
        this.insuranceNamePopup = $event;
        this.insuranceNamemain = '';
        if (type == 'main') {
          this.translateService.get('button.add').subscribe((translation: string) => {
            this.insurancetype = translation;
          });
          //this.insurancetype = "Add";
          this.insurancemodel = false;
        }
        else if (type == 'popup') {

        }
        this.add_insurance_manual();

      }
    }
  }
  validateInsuranceinfo(field: any, type: any) {
    if (type === "groupid") {
      let num = field.value.replace(/\D/g, '');
      field.value = num;
      this._addpatientinsurancemodel.groupId = num;
    } else
      if (type === "policyid") {
        let num = field.value.replace(/\D/g, '');
        field.value = num;
        this._addpatientinsurancemodel.policyNumber = num;
      }
  }

  ShowSubscriberForm(type: any) {

    if (type == undefined || type.target.value != "S") {
      this.isShowSubscriberForm = true;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      $('#Insurance-Modal').modal('hide');
      $('#Subscriber-Modal').modal('show');
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.subSAction = translation;
      });
      // this.subSAction="Add";
    }
    else {
      this.isShowSubscriberForm = false;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this.subcriberReq = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      $('#Subscriber-Modal').modal('hide');
    }
  }
  ShowSubscriberButton(type: any) {

    if (type == undefined || type.target.value != "S") {
      if ((this._addpatientinsurancemodel.subscriber && this._addpatientinsurancemodel.guarantoR_CODE) || (this._updatesubscriberinfo.guaranT_FNAME && this._updatesubscriberinfo.guaranT_LNAME)) {
        return;
      }
      else {
        this.isShowSubscriberForm = true;
      }
    }
    else {
      this.isShowSubscriberForm = false;
      this._addpatientinsurancemodel.subscriber = '';
      this._addpatientinsurancemodel.guarantoR_CODE = '';
      this.subcriberReq = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
    }
  }
  validateName(inputName: any, type: any, name: any) {
    let validname = inputName.value.replace(/[^a-zA-Z]/g, "");
    inputName.value = validname;
    if (type === "subscriber") {
      if (name === 'first') {
        this._updatesubscriberinfo.guaranT_FNAME = validname;
      }
      else
        if (name === 'last') {
          this._updatesubscriberinfo.guaranT_LNAME = validname;
        }
    }

  }
  onFocusOutCity(event: any) {

    let data = event.target.value;
    this._cityandstateList.map((res: any) => {
      if (res.cityName == data) {
        this._updatesubscriberinfo.guaranT_CITY = res.cityName;
        this._updatesubscriberinfo.guaranT_STATE = res.stateCode;
      }
    })
  }
  onFocusOutZIPSubsciber(event: any, type: any) {

    let zipcode;
    if (type == 1) {
      zipcode = event.replace(/\D/g, '');
      zipcode = this._phrutilService.maskingZipNum(zipcode);
      this._updatesubscriberinfo.guarant_zip = zipcode;
    } else {
      let phoneNumDigits = event.value.replace(/\D/g, '');
      phoneNumDigits = this._phrutilService.maskingZipNum(phoneNumDigits);
      event.value = phoneNumDigits;
      zipcode = event.value;
      this._updatesubscriberinfo.guarant_zip = zipcode;
    }
    zipcode = zipcode.replace(/\D/g, '');
    this._cityandstateList = [];
    if (zipcode && (zipcode.length == 5 || zipcode.length == 9)) {

      this.spinner.show();
      //this.CityandStateRequest.ZIP_CODE = zipcode;
      this.UpdateinfoService.getZipCityState(zipcode, this.PatientAccount, this.PracticeCode).subscribe((res: any) => {

        this.spinner.hide();
        if (res.data && res.data.length > 0) {
          this.isZipCodeNotValidSuubscriberInfo = false;
          this._cityandstateList = res.data;
          if (type == 0) {
            this._updatesubscriberinfo.guaranT_CITY = this._cityandstateList[0].cityName;
            this._updatesubscriberinfo.guaranT_STATE = this._cityandstateList[0].stateCode;
          } else
            if (type == 1) {
              this._cityandstateList.map((res: any) => {
                if (res.cityName.trim() == this._updatesubscriberinfo.guaranT_CITY.trim())
                  this._updatesubscriberinfo.guaranT_CITY = res.cityName.trim();
                if (res.stateCode.trim() == this._updatesubscriberinfo.guaranT_STATE.trim())
                  this._updatesubscriberinfo.guaranT_STATE = res.stateCode.trim();
              });
            }
        } else {
          this.isZipCodeNotValidSuubscriberInfo = true;
          this.zipLengthReq = true;
          this._updatesubscriberinfo.guaranT_CITY = "";
          this._updatesubscriberinfo.guaranT_STATE = "";
        }
        $('#Subscriber-Modal').modal('show');
      },
        (error: any) => {
          this.isZipCodeNotValidSuubscriberInfo = true;
          this.zipLengthReq = true;
          this._updatesubscriberinfo.guaranT_CITY = "";
          this._updatesubscriberinfo.guaranT_STATE = "";
          this.spinner.hide('Subscriberinfospinner');
          $('#Subscriber-Modal').modal('show');
        })
    }
    else {
      $('#Subscriber-Modal').modal('show');
      this._cityandstateList = [];
      this._updatesubscriberinfo.guaranT_CITY = "";
      this._updatesubscriberinfo.guaranT_STATE = "";
    }
  }
  keyPressNumbers(event: any) {
    this._phrutilService.keyPressNumbers(event);
  }
  ValidateAddress(inputName: any, type: any, name: any) {

    let validname = inputName.value.replace(/[^/#.0-9a-zA-Z\s,-]/g, "");
    inputName.value = validname;
    if (type === "subscriber") {
      this._updatesubscriberinfo.guaranT_ADDRESS = validname;
    }
  }
  ResetSubscriberData() {
    if (!this._updatesubscriberinfo.guarantoR_CODE) {
      this._firstNameReq = false;
      this._lastNameReq = false;
      this.subcriberReq = false;
      this.addressReq = false;
      this.zipReq = false;
      this.zipLengthReq = false;
      this.isDateError = false;
      this._updatesubscriberinfo = new UpdateSubscriberInfo();
      this.closeCaptureCard('reset');
    }
    if (this._updatesubscriberinfo.guarant_dob && this._updatesubscriberinfo.guarant_dob.length != '') {
      this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'MM/dd/yyyy');
    }
  }
  CloseSubscriberModel() {
    $('#Subscriber-Modal').modal('hide');
    // $('#Insurance-Modal').modal('show');
    this.addInsurance = true;
  }
  ValidateSubscriber() {
    this._updatesubscriberinfo.guarant_zip = this._updatesubscriberinfo.guarant_zip.replace(/\D/g, '');
    if (this._updatesubscriberinfo.guarant_zip == '' || this._updatesubscriberinfo.guarant_zip == undefined || this._updatesubscriberinfo.guarant_zip == null) {
      this._updatesubscriberinfo.guarant_zip = '';
      this._updatesubscriberinfo.guaranT_CITY = '';
      this._updatesubscriberinfo.guaranT_STATE = '';
    }
    if (this._updatesubscriberinfo.guaranT_FNAME == "" || this._updatesubscriberinfo.guaranT_FNAME.trim().length <= 0 || this._updatesubscriberinfo.guaranT_FNAME == undefined) {
      this._firstNameReq = true;
      return false;
    }
    else {
      this._firstNameReq = false;
    }
    if (this._updatesubscriberinfo.guaranT_LNAME == "" || this._updatesubscriberinfo.guaranT_LNAME.trim().length <= 0 || this._updatesubscriberinfo.guaranT_LNAME == undefined) {
      this._lastNameReq = true;
      return false;
    }
    else {
      this._lastNameReq = false;
    }


    if (this.isDateError) {
      return false;
    }
    if (this._updatesubscriberinfo.guaranT_ADDRESS == "" || this._updatesubscriberinfo.guaranT_ADDRESS.trim().length <= 0 || this._updatesubscriberinfo.guaranT_ADDRESS == undefined) {
      this.addressReq = true;
      return false;
    }
    else {
      this.addressReq = false;
    }
    if (this._updatesubscriberinfo.guarant_zip == "" || this._updatesubscriberinfo.guarant_zip.trim().length <= 0 || this._updatesubscriberinfo.guarant_zip == undefined) {
      this.zipReq = true;
      return false;
    }
    else {
      this.zipReq = false;
    }
    if (this._updatesubscriberinfo.guarant_zip.length > 0 && (this._updatesubscriberinfo.guarant_zip.length != 5 && this._updatesubscriberinfo.guarant_zip.length != 9)) {
      this.isZipCodeNotValidSuubscriberInfo = true;
      return false;
    }
    else {
      this.zipLengthReq = false;
    }

    if (!this.isZipCodeNotValidSuubscriberInfo) {
      if (!this._updatesubscriberinfo.guarant_zip) {
        this.zipReq = true;
        return false;
      }

      else {
        this.zipReq = false;
      }
    } else {
      return false;
    }

    this._addpatientinsurancemodel.subscriber = this._updatesubscriberinfo.guaranT_FNAME + ' ' + this._updatesubscriberinfo.guaranT_LNAME;
    if (this._updatesubscriberinfo.guarant_dob && this._updatesubscriberinfo.guarant_dob.length != '') {
      this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'MM/dd/yyyy');
    }

    this.subcriberReq = true;
    $('#Subscriber-Modal').modal('hide');
    //$('#Insurance-Modal').modal('show');
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.isShowSubscriberForm = false;
    return true;
  }

  AddinsuranceBycard: boolean = true;
  addInsurancemanually: boolean = false;

  addInsuranceManuallyNew() {
    this.filterInsuranceSearch = [];
    this.dNoneInsurance = true;
    this.insuranceNamePopup = '';
    this.insuranceNamemain = '';
    this.ClearInsuranceInfo();
    this.insurancemodel = false;
    this.addInsurance = true;
    this.InsuranceDetails = false;
    this.addInsurancemanually = true;
    this.AddinsuranceBycard = false;
    this.searchinsuranceresponce.insurancE_ID = '';
    this._addpatientinsurancemodel.relationship = 'S';
    const insurancetype = localStorage.getItem("itype")
    console.log("istype " + insurancetype);

    if (this.isPrimaryInsuranceInactive == true) {
      this.insurancecat = 'P';
    } else {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {
        this.insurancecat = 'O';

      } else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        this.insurancecat = 'S';

      } else {
        this.insurancecat = 'P';

      }
    }
  }
  InsuranceDetailsNew() {
    this.InsuranceDetails = true;
    this.addInsurance = false;
    this.AddinsuranceBycard = false;
    this.addInsurancemanually = false;
    this._addpatientinsurancemodel.insuranceId = '';
    this.fileObjFront = '';
    this.fileObjBack = '';
  }
  addInsuranceBycard() {
    this.ClearInsuranceInfo();
    this.fileObjFront = '';
    this.fileObjBack = '';
    this.AddinsuranceBycard = true;
    this.addInsurancemanually = false;
    this.isFrontPhotoUpload = false;
    this.isbackPhotoUpload = false;
    this.isRequireFrontCard = false;
    this.isRequireBackCard = false;
    this.insurancemodel = false;
    this.addInsurance = true;
    this.InsuranceDetails = false;
    const insurancetype = localStorage.getItem("itype")
    console.log("itype " + insurancetype);

    if (this.isPrimaryInsuranceInactive == true) {
      this.insurancecat = 'P';
    } else {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S')) {

        this.insurancecat = 'O';

      } else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {

        this.insurancecat = 'S';

      } else {

        this.insurancecat = 'P';

      }
    }



  }

  mainInsuranceNew() {
    if (this.isPrimaryInsuranceInactive == false) {
      if (this._insurances.length == 3) {
        let text = "You cannot add more then 3 insurance";
        this.translateService.get('Alerts.insurance_moreThan_3').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        return;
      }
      this.addInsuranceBycard();
    } else {
      this.addInsuranceBycard();
    }

    //this.addInsuranceManuallyNew();

  }

  ClickInsuranceInfo(cat: any, isAddInsurance: any) {
    //cat for insurance category (P,S,O)
    //isAddInsurance is to identify this method is call from update insurance or add insuarnce (true/false) 
    if (cat == 'P') {
      this.insurancecat = cat;
    }
    else
      if (cat == 'S') {
        if (isAddInsurance) {
          if (this.isPrimeryInsuranceAvailable()) {
            this.insurancecat = cat;
          }
          else {
            this.ToggleInsuranceModel(false);
          }
        }
        else {
          this.insurancecat = cat;
        }
      }
      else
        if (cat == 'O') {
          this.insurancecat = cat;
        }
        else {
          this.insurancecat = 'P';
        }

  }

  ToggleInsuranceModel(ishowInsuranceModel: any) {
    if (ishowInsuranceModel) {
      $("#PrimeryinsuranceNotAvailable").modal("hide");
      //$("#Insurance-Modal").modal("show");
      this.addInsurance = true;
      this.AddinsuranceBycard = true;
      this.addInsurancemanually = false;
      this.addInsuranceBycard();
    }
    else {
      $("#PrimeryinsuranceNotAvailable").modal("show");
      $("#Insurance-Modal").modal("hide");
    }
  }

  isPrimeryInsuranceAvailable() {

    if (this._insurances.map(res => res.prI_SEC_OTH_TYPE == 'P')?.length > 0) {
      return true;
    }
    else {
      return false;
    }

  }

  //GetPatientInsuranceInfo(patientAccount: any, practiceCode: any,) {
  //  this.spinner.show();
  //  this._insuranceservice.GetPatientInsuranceInfo(patientAccount, practiceCode).subscribe((res: any) => {

  //    this.spinner.hide();
  //    if (res.statusCode == 200) {
  //      this._insurances = res.data as PatienT_INSURANCE_INFO[];
  //      this._insurances.map((res: any) => {

  //        if (res.inspayeR_DESCRIPTION.toLowerCase().includes("medicare") ||
  //          res.inspayeR_DESCRIPTION.toLowerCase().includes("cigna") ||
  //          res.inspayeR_DESCRIPTION.toLowerCase().includes("aetna medicare") ||
  //          res.inspayeR_DESCRIPTION.toLowerCase().includes("railroad")) {

  //          res.is_OCR_exist = true;
  //        }
  //        else {
  //          res.is_OCR_exist = false;
  //        }

  //      })


  //    } else {
  //      let text = "Service is not available, please try later.";
  //      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
  //        text = translation;
  //      });
  //      this._phrutilService.showError(text);
  //      //this._phrutilService.showError("Service is not available, please try later.");
  //    }

  //  },
  //    (error: any) => {
  //      this.spinner.hide();
  //      let text = "Service is not available, please try later.";
  //      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
  //        text = translation;
  //      });
  //      this._phrutilService.showError(text);
  //      //this._phrutilService.showError("Service is not available, please try later.");
  //    })
  //}

  GetPatientInsuranceInfo(patientAccount: any, practiceCode: any, appointmentId: any) {
    this.spinner.show();
    this._insuranceservice.GetPatientInsuranceInfo(patientAccount, practiceCode, appointmentId).subscribe((res: any) => {

      this.spinner.hide();
      if (res.statusCode == 200) {
        this._insurances = res.data as PatienT_INSURANCE_INFO[];
        console.log(this._insurances.length);
        if (this._insurances.length > 0) {
          this.InsuranceDetailsNew();
          const newIns = localStorage.getItem("newIns");
          console.log("new insurance", newIns);
          if (newIns != null)
            this.newPrimaryInsuranceAdded = newIns;
          if (this.newPrimaryInsuranceAdded == false) {
            if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
              this.isPrimaryInsurancealredyExist = true;
              const status = this._insurances.find(res => res.prI_SEC_OTH_TYPE === 'P')
              this.insuranceStatus = status?.insurancE_STATUS;
              this.pcpStatus = status?.pcP_STATUS;
              console.log("insurance status ", this.insuranceStatus);
              console.log("PCP status ", this.pcpStatus);
              if (this.insuranceStatus != undefined && this.insuranceStatus != null && this.insuranceStatus != '') {

                this.insuranceStatus = this.insuranceStatus.toLowerCase();
                if (this.insuranceStatus == 'rejected' || this.insuranceStatus == 'inactive') {
                  this.isPrimaryInsuranceInactive = true;
                } else {
                  this.isPrimaryInsuranceInactive = false;
                }
                console.log("insurance status ", this.insuranceStatus);
              } else {
                this.insuranceStatus = '';
                this.isPrimaryInsuranceInactive = false;
              }

              if (this.pcpStatus != undefined && this.pcpStatus != null && this.pcpStatus.trim() !== '') {
                console.log("pcp status inside ", this.pcpStatus);
                this.pcpStatus = this.pcpStatus.toLowerCase();

                if (this.pcpStatus == 'pcp mismatch') {
                  this.notificationCount = 1;
                  this.showNotificationIcon = true;
                } else {
                  this.showNotificationIcon = false;
                }
              } else {
                this.pcpStatus = '';
                this.showNotificationIcon = false;
              }
            } else {
              this.isPrimaryInsuranceInactive = false;
              this.showNotificationIcon = false;
            }
          }


          //this.InsuranceDetails = true;
          //this.addInsurance = false;
          //this.AddinsuranceBycard = false;
          //this.addInsurancemanually = false;
        } else {
          if (this.isphotoupload) {
            this.nextClick()
          } else {
            this.InsuranceDetails = false;
            this.addInsurance = true;
            this.isPrimaryInsuranceInactive = false;
            this.showNotificationIcon = false;
            localStorage.setItem("insStatus", '');
            this.addInsuranceBycard();
          }

        }

        this._insurances.map((res: any) => {

          if (res.inspayeR_DESCRIPTION.toLowerCase().includes("medicare") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("cigna") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("aetna medicare") ||
            res.inspayeR_DESCRIPTION.toLowerCase().includes("railroad")) {

            res.is_OCR_exist = true;
          }
          else {
            res.is_OCR_exist = false;
          }

        })


      } else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }

    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }

  policyNumberError: boolean = false;
  insurance_type: string = '';
  //Add_Insurance_Info_confirmation_model() {

  //  if (!this._addpatientinsurancemodel.insuranceId && !this.UpdateInsuranceModel.insuranceId) {
  //    this.insuranceNameError = true;
  //    return false;
  //  }
  //  else {
  //    this.insuranceNameError = false;
  //  }
  //  if (this._addpatientinsurancemodel.policyNumber == "" || this._addpatientinsurancemodel.policyNumber == null || this._addpatientinsurancemodel.policyNumber == undefined) {
  //    this.policyNumberError = true;
  //    return false;
  //  } else {
  //    this.policyNumberError = false;
  //  }
  //  if (this.insurancecat == undefined) {
  //    this.insurancecat = 'P';
  //    this._addpatientinsurancemodel.type = this.insurancecat;
  //  }
  //  else
  //    this._addpatientinsurancemodel.type = this.insurancecat;

  //  if (this._addpatientinsurancemodel.relationship != "S") {
  //    if (!this.subcriberReq && (this._addpatientinsurancemodel.subscriber == undefined || this._addpatientinsurancemodel.subscriber == null || this._addpatientinsurancemodel.subscriber.length == 0)) {
  //      let text = "Select Relation as 'Self' or add Subscriber";
  //      this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
  //        text = translation;
  //      });
  //      this._phrutilService.showInfo(text);
  //     // this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
  //      return false;
  //    }
  //  }
  //  $("#Insurance-Modal").modal("hide");
  //  /*
  //  Hidding Confirmation Dialog and directly calling addInsurance method
  //  As per mentioned by Adeel Sarwar
  //  Developer : - Asad Iftikhar
  //  Date : - 12-23-2023
  //  */
  //  // $("#insurancesavemodal").modal("show");
  //  this.Addinsurance();
  //  return true;
  //}
  Add_Insurance_Info_confirmation_model() {
    console.log(this.fileArray.length);
    console.log(this.isRequireFrontCard);
    console.log(this.searchinsuranceresponce.insurancE_ID);
    const insuranceId = this.searchinsuranceresponce.insurancE_ID;
    const isInsuranceAlredyExist = this._insurances.some((insurance) => {
      return insurance.insurancE_ID === insuranceId;
    });
    if (isInsuranceAlredyExist) {
      let text = "This insurance is already exist.";
      this.translateService.get('insurances.insurance_alredy_exist').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      //this._phrutilService.showInfo("This insurance is already exist.");
      return false;
    }
    if (!this._addpatientinsurancemodel.insuranceId && !this.UpdateInsuranceModel.insuranceId) {
      this.insuranceNameError = true;
      return false;
    }
    else {
      this.insuranceNameError = false;
    }
    if (this._addpatientinsurancemodel.policyNumber == "" || this._addpatientinsurancemodel.policyNumber == null || this._addpatientinsurancemodel.policyNumber == undefined) {
      this.policyNumberError = true;
      return false;
    } else {
      this.policyNumberError = false;
    }
    if (this.insurancecat == undefined) {
      this.insurancecat = 'P';
      this._addpatientinsurancemodel.type = this.insurancecat;
    }
    else
      this._addpatientinsurancemodel.type = this.insurancecat;

    if (this._addpatientinsurancemodel.relationship != "S") {
      if (!this.subcriberReq && (this._addpatientinsurancemodel.subscriber == undefined || this._addpatientinsurancemodel.subscriber == null || this._addpatientinsurancemodel.subscriber.length == 0)) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
    }

    $("#Insurance-Modal").modal("hide");
    // $("#insurancesavemodal").modal("show");
    this.Addinsurance();
    return true;
  }
  noAgree() {
    this.addInsurance = true;
    this.addInsuranceManuallyNew();
    //$("#Insurance-Modal").modal("show");
  }
  Addinsurance() {
    let idList = [];
    if (this._insurances)
      for (let checklimit of this._insurances) {
        idList.push(checklimit.id);
      }
    // Check Save Update
    if (this.insurancemodel == false) {
      if (idList.length >= 3 && this.insurancemodel == false) {
        let text = "You cannot add more then 3 insurance";
        this.translateService.get('Alerts.insurance_moreThan_3').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("You cannot add more then 3 insurance");
      } else
        if (idList.length == 2) {
          if (idList[0] == '1' && idList[1] == '2') {
            if (this.insurancecat === 'P') {
              let text = "You can only add one primary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              // this._phrutilService.showInfo("You can only add one primary insurance");
            } else if (this.insurancecat === 'S') {
              let text = "You can only add one secondary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              //this._phrutilService.showInfo("You can only add one secondary insurance");
            } else {
              if (this.insurancemodel)
                this.Update_Insurance_Info();
              else
                this.Add_insurance_info();
            }
          } else
            if (idList[0] == '1' && idList[1] == '3') {
              if (this.insurancecat === 'P') {
                let text = "You can only add one primary insurance";
                this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                // this._phrutilService.showInfo("You Can Only Add One Primary Insurance");
              } else if (this.insurancecat === 'O') {
                let text = "You Can Only Add One Other Insurance";
                this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                //this._phrutilService.showInfo("You Can Only Add One Other Insurance");
              } else {
                if (this.insurancemodel)
                  this.Update_Insurance_Info();
                else
                  this.Add_insurance_info();
              }
            } else
              if (idList[0] == '2' && idList[1] == '3') {
                if (this.insurancecat === 'S') {
                  let text = "You can only add one secondary insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  //this._phrutilService.showInfo("You Can Only Add One Secondary Insurance");
                } else if (this.insurancecat === 'O') {
                  let text = "You Can Only Add One Other Insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  //this._phrutilService.showInfo("You Can Only Add One Other Insurance");
                } else {
                  if (this.insurancemodel)
                    this.Update_Insurance_Info();
                  else
                    this.Add_insurance_info();
                }
              }
        }
        else
          if (idList.length == 1) {
            if (idList[0] == '1' && this.insurancecat === 'P') {
              let text = "You can only add one primary insurance";
              this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              //this._phrutilService.showInfo("You can only add one primary insurance");
            } else
              if (idList[0] == '2' && this.insurancecat == 'S') {
                let text = "You can only add one secondary insurance";
                this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                // this._phrutilService.showInfo("You can only add one secondary insurance");
              } else
                if (idList[0] == '3' && this.insurancecat === 'O') {
                  let text = "You Can Only Add One Other Insurance";
                  this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                    text = translation;
                  });
                  this._phrutilService.showInfo(text);
                  //this._phrutilService.showInfo("You can only add one Other insurance");
                } else {
                  if (this.insurancemodel)
                    this.Update_Insurance_Info();
                  else
                    this.Add_insurance_info();
                }
          }
          else {
            if (this.insurancemodel == false) {
              if (this.insurancemodel)
                this.Update_Insurance_Info();
              else
                this.Add_insurance_info();
            }
            else {
              if (this.insurance_type == this.insurancecat) {
                if (this.insurancemodel)
                  this.Update_Insurance_Info();
                else
                  this.Add_insurance_info();
              } else {
                let text = "You Can Only Add One Other Insurance";
                this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
                  text = translation;
                });
                this._phrutilService.showInfo(text);
                //this._phrutilService.showInfo("You can only add one Other insurance");
              }
            }
          }
    }
    else {
      if (this.insurancemodel)
        this.Update_Insurance_Info();
      else
        this.Add_insurance_info();
    }
    return true;
  }
  showconfirmationmodal() {
    if (this._addpatientinsurancemodel.insuranceId || (this.UpdateInsuranceModel.insuranceId && this.isNotOCRinsurance)) {
      $("#Insurance-Modal").modal("hide");
      $("#insuranceclosemodel").modal("show");
      //this.HideVerifyDetail=false;
    }
    else {
      this.ClearInsuranceInfo();
    }
  }
  ClearInsuranceInfo() {
    $("#Insurance-Modal").modal("hide");
    this.searchinsurancemodel.insuranceName = "";
    this.insuranceNameError = false;
    this.policyNumberError = false;
    this.insurancecat = 'P';
    this.isShowSubscriberForm = false;
    this._addpatientinsurancemodel = new AddInsuranceModel();
    this.UpdateInsuranceModel = new UpdateInsuranceModel();
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this.ResetSubscriberData();
  }
  async Update_Insurance_Info() {
    if (this._addpatientinsurancemodel.relationship != "S") {

      if (!this.subcriberReq && (this._addpatientinsurancemodel.guarantoR_CODE == null || this._addpatientinsurancemodel.guarantoR_CODE == undefined || this._addpatientinsurancemodel.guarantoR_CODE.length == 0)) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        // this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        await this.AddSubscriberInfo();
      }

      if ((this._guarantor == undefined || this._guarantor == null) && (this._addpatientinsurancemodel.guarantoR_CODE == null || this._addpatientinsurancemodel.guarantoR_CODE == undefined || this._addpatientinsurancemodel.guarantoR_CODE.length == 0)) {
        this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else if (this._addpatientinsurancemodel.guarantoR_CODE != null && this._addpatientinsurancemodel.guarantoR_CODE != undefined && this._addpatientinsurancemodel.guarantoR_CODE.length > 1) {
        this.UpdateInsuranceModel.subscriber = this._addpatientinsurancemodel.guarantoR_CODE;
      }
      else {
        this.UpdateInsuranceModel.subscriber = this._guarantor.guarantorCode;
      }
    }
    else {
      this.UpdateInsuranceModel.subscriber = '';
    }
    this.UpdateInsuranceModel.patientAccount = this.PatientAccount.toString();
    this.UpdateInsuranceModel.practiceCode = this.PracticeCode;
    this.UpdateInsuranceModel.allowedVisit = this._addpatientinsurancemodel.allowedVisit;
    this.UpdateInsuranceModel.copay = this._addpatientinsurancemodel.copay;
    this.UpdateInsuranceModel.copayPercent = this._addpatientinsurancemodel.copayPercent;
    this.UpdateInsuranceModel.createdBy = this.PatientAccount.toString();
    this.UpdateInsuranceModel.deductable = this._addpatientinsurancemodel.deductable;
    this.UpdateInsuranceModel.effectiveFrom = this._addpatientinsurancemodel.effectiveFrom;
    this.UpdateInsuranceModel.effectiveTo = this._addpatientinsurancemodel.effectiveTo;
    this.UpdateInsuranceModel.groupId = this._addpatientinsurancemodel.groupId;
    this.UpdateInsuranceModel.groupName = this._addpatientinsurancemodel.groupName;
    this.UpdateInsuranceModel.policyNumber = this._addpatientinsurancemodel.policyNumber;
    this.UpdateInsuranceModel.relationship = this._addpatientinsurancemodel.relationship;
    this.UpdateInsuranceModel.type = this.insurancecat;
    this._addpatientinsurancemodel.type = this.insurancecat;
    this.UpdateInsuranceModel.wcInfo = this._addpatientinsurancemodel.wcInfo;
    this.spinner.show();
    this._insuranceservice.UpdatePatientInsurance(this.UpdateInsuranceModel).subscribe((res: any) => {
      $('#Insurance-Modal').modal('hide');
      this.spinner.hide();
      this.ClearInsuranceInfo();
      if (res.statusCode == 200) {
        let text = "Insurance updated successfully";
        this.translateService.get('Alerts.insurance_updated').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Insurance updated successfully");
        this.GetPatientInsuranceInfo(this.PatientAccount, this.PracticeCode, this.appointmentId);
        return true;
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // this._phrutilService.showError("Service is not available, please try later.");
      })
    return true;
  }
  async Add_insurance_info() {
    if (this._addpatientinsurancemodel.relationship != "S") {
      if (!this.subcriberReq) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        await this.AddSubscriberInfo();
      }

      if (this._guarantor == undefined || this._guarantor == null) {
        let text = "Select Relation as 'Self' or add Subscriber";
        this.translateService.get('Alerts.insurance_select_relation_as_self').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Select Relation as 'Self' or add Subscriber");
        return false;
      }
      else {
        this._addpatientinsurancemodel.subscriber = this._guarantor.guarantorCode;
      }
    }
    this._addpatientinsurancemodel.createdBy = this.PatientAccount.toString();
    this._addpatientinsurancemodel.patientAccount = this.PatientAccount;
    this._addpatientinsurancemodel.practiceCode = this.PracticeCode;
    this._addpatientinsurancemodel.type = this.insurancecat;
    this.spinner.show();
    this._insuranceservice.AddPatientInsurance(this._addpatientinsurancemodel).subscribe((res: any) => {
      $('#Insurance-Modal').modal('hide');
      this.spinner.hide();
      this.ClearInsuranceInfo();
      if (res.statusCode == 200) {
        this.GetPatientInsuranceInfo(this.PatientAccount, this.PracticeCode, this.appointmentId);
        let text = "Insurance added successfully";
        this.translateService.get('Alerts.insurance_added').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        // this._phrutilService.showSuccess("Insurance added successfully");
        return true;
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
    return true;
  }
  DeleteInactiveInsurance(insurance: any) {
    console.log("delete Insurance ", insurance);
    this._deletepatientinsurance.modifiedBy = this.PatientAccount;
    this._deletepatientinsurance.insuranceId = insurance.insurancE_ID;
    this._deletepatientinsurance.patientAccount = this.PatientAccount;
    this._deletepatientinsurance.practiceCode = this.PracticeCode;

    // return;
    this._insuranceservice.DeletePatientInsurance(this._deletepatientinsurance).subscribe((res: any) => {

      if (res.statusCode == 200) {
        console.log("Inactive insurance has been deleted successfully!!");
        this.isPrimaryInsuranceInactive = false;
        localStorage.setItem("insStatus", '');
      }
      else {
        console.log("Something went wrong");
      }

    },
      (error: any) => {
        console.log("Errors");
      })
  }

  AddinsurancePhoto() {
    //this.callOCRinsuranceService();
    if (this.fileObjFront) {
      this.isRequireFrontCard = false;
      this.scrollToBackInput();
      // this.fileArray.push(this.fileObjFront);
    }
    else {
      this.isRequireFrontCard = true;
      this.scrollTobuttomandTop(true);
      return;
    }
    if (this.fileObjBack) {
      this.isRequireBackCard = false;
      //this.fileArray.push(this.fileObjBack);
    }
    else {
      this.scrollTobuttomandTop(false);
      this.isRequireBackCard = true;
      return;
    }

    //check if primary insurance is already exist and inactive then delete it
    if (this.isPrimaryInsuranceInactive == true && this.insurancecat === 'P') {
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P')) {
        const result = this._insurances.find(res => res.prI_SEC_OTH_TYPE === 'P')
        this.DeleteInactiveInsurance(result);
      }
    }


    //  Primary_front
    if (this.insurancecat === 'P') {
      this.insuranceType = 'Primary'
    } else if (this.insurancecat === 'S') {
      this.insuranceType = 'Secondary'
    } else {
      this.insuranceType = 'Other'
    }

    this.spinner.show();
    if (this.fileObjFront) {
      const subtype = this.insuranceType + "_Insurance_" + "Front";
      //this._intakeMedicationService.uploadAtFolder(this.fileObjFront, "api/TalkCheckin/SaveMedicine_Photo", this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
      this._InsuranceService.uploadAtFolder(this.fileObjFront, "api/TalkCheckin/SaveInsurances_Photo_EHR", this.PatientAccount, this.PracticeCode, subtype).subscribe((res: any) => {
        // this.spinner.hide();
        //$("#Medical-History-Modal").modal("hide");
        if (res.statusCode == 200) {
          console.log("back" + this.fileObjBack)
          this.addBackPhoto();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);

          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      );
    }
  }
  insuranceType: any;
  isphotoupload: any = false;
  newPrimaryInsuranceAdded: any = false;

  addBackPhoto() {
    console.log("back photo upload")
    console.log("back" + this.fileObjBack)
    if (this.fileObjBack) {
      console.log("back" + this.fileObjBack)
      const subtype = this.insuranceType + "_Insurance_" + "Back";

      //this._insuranceservice.uploadAtFolder(this.fileObjBack, "api/TalkCheckin/SaveInsurances_Photo", this.PatientAccount, this.PracticeCode, subtype).subscribe((res: any) => {
      this._InsuranceService.uploadAtFolder(this.fileObjBack, "api/TalkCheckin/SaveInsurances_Photo_EHR", this.PatientAccount, this.PracticeCode, subtype).subscribe((res: any) => {
        this.spinner.hide();
        console.log("back uploaded")
        if (res.statusCode == 200) {
          let text = "Thank you for providing your insurance details. Your doctor will update your file accordingly.";
          this.translateService.get('insurances.thank_you').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showSuccess(text);
          this.isphotoupload = true;
          if (this.insurancecat === 'P') {
            this.isPrimaryInsuranceInactive = false;
            this.newPrimaryInsuranceAdded = true;
            localStorage.setItem("newIns", this.newPrimaryInsuranceAdded)
            this.appointmentId = '0';
          }
          // this._phrutilService.showSuccess('Thank you for providing your insurance details. Your doctor will update your file accordingly.');
          this.GetPatientInsuranceInfo(this.PatientAccount, this.PracticeCode, this.appointmentId);
          //localStorage.setItem("itype", this.insuranceType);
          //const insurancetype = localStorage.getItem("itype")
          //console.log("istype " + insurancetype);
          //if (insurancetype === 'Secondary') {
          //  this.insurancecat = 'O';
          //} else if (insurancetype === 'Primary') {
          //  this.insurancecat = 'S';
          //} else {
          //  this.insurancecat = 'P';
          //}

          this.fileObjFront = '';
          this.fileObjBack = '';
          this.fileArray = Array();
          this.isFrontPhotoUpload = false;
          this.isbackPhotoUpload = false;
          // this.ClearInsuranceInfo();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        }
      );
    }
  }
  async AddSubscriberInfo() {

    this._updatesubscriberinfo.modified_By = this.PatientAccount.toString();
    this._updatesubscriberinfo.patientAccount = this.PatientAccount;
    this._updatesubscriberinfo.practiceCode = this.PracticeCode;
    this._updatesubscriberinfo.GUARANT_PRACTICE_CODE = this.PracticeCode;
    this._updatesubscriberinfo.GUARANT_TYPE = "S";
    this.spinner.show();
    await this._insuranceservice.AddSubscriber(this._updatesubscriberinfo).then((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200) {
        this._guarantor = res.data as AddSubscriberResponse;
        return true;
      }
      else {
        this.spinner.hide();
        return false;
      }
    },
      (error: any) => {
        this.spinner.hide();
      })

  }
  isNotOCRinsurance: any = true;

  addInsurancemodle(patientinsuranceinfo: any, checkinsurance: boolean, isManual = false) {

    this.ClearInsuranceInfo();
    this.insurancemodel = checkinsurance;

    if (patientinsuranceinfo != undefined && this.insurancemodel == true) {
      this.translateService.get('button.update').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Update"
      this.spinner.show();
      this.UpdateInsuranceModel.patientInsuranceId = patientinsuranceinfo.patienT_INSURANCE_ID;
      this.UpdateInsuranceModel.insuranceId = patientinsuranceinfo.insurancE_ID;

      this.displayInsuranceName = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this.searchinsurancemodel.insuranceName = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this.insuranceNamePopup = patientinsuranceinfo.inspayeR_DESCRIPTION;
      this._addpatientinsurancemodel.groupName = patientinsuranceinfo.group_Name;
      this._addpatientinsurancemodel.groupId = patientinsuranceinfo.group_Number;
      this._addpatientinsurancemodel.subscriber = (patientinsuranceinfo.subscriber.length >= 3) ? patientinsuranceinfo.subscriber : null;
      this._addpatientinsurancemodel.guarantoR_CODE = patientinsuranceinfo.guarantoR_CODE;
      this._addpatientinsurancemodel.policyNumber = patientinsuranceinfo.policY_NUMBER;
      let dob = patientinsuranceinfo.effective_Date;
      if (dob) {
        this._addpatientinsurancemodel.effectiveFrom = this.datepipe.transform(dob, 'yyyy-MM-dd');
      } else {
        this._addpatientinsurancemodel.effectiveFrom = "";
      }
      let dob1 = patientinsuranceinfo.termination_Date;  //.substr(0, 10);
      if (dob1) {
        this._addpatientinsurancemodel.effectiveTo = this.datepipe.transform(dob1, 'yyyy-MM-dd');
      } else {
        this._addpatientinsurancemodel.effectiveTo = "";
      }

      this._addpatientinsurancemodel.relationship = patientinsuranceinfo.relationship;
      this._addpatientinsurancemodel.allowedVisit = patientinsuranceinfo.allowed_Visits;
      this._addpatientinsurancemodel.copayPercent = patientinsuranceinfo.cO_PAYMENT_PER;
      this._addpatientinsurancemodel.copay = patientinsuranceinfo.co_Payment;
      this._addpatientinsurancemodel.deductable = patientinsuranceinfo.deductions;
      this._addpatientinsurancemodel.wcInfo = patientinsuranceinfo.filing_indicator;
      this.insurance_type = patientinsuranceinfo.prI_SEC_OTH_TYPE;
      this.ClickInsuranceInfo(patientinsuranceinfo.prI_SEC_OTH_TYPE, false);
      this.GetSubscriberDetails(this._addpatientinsurancemodel.guarantoR_CODE);
      if (isManual) {
        this.isNotOCRinsurance = true;
        this.addInsurance = true;
        this.addInsuranceManuallyNew();
        this.InsuranceDetails = false;
        // $('#Insurance-Modal').modal('show');
      }
      else {
        this.isNotOCRinsurance = true;
        $('#Captured-Modal').modal('show');
      }
    }
    else {
      this.isNotOCRinsurance = false;
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Add";
      this._addpatientinsurancemodel.relationship = 'S';
      $('#Insurance-Modal').modal('show');
    }
    return true;
  }
  GetSubscriberDetails(guarantoR_CODE: any) {
    if (guarantoR_CODE && guarantoR_CODE.length > 1) {
      this._insuranceservice.GetSubscriberDetails(this.PracticeCode, this.PatientAccount, guarantoR_CODE).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          this.getSubscriberDetails = res.data;
          this.subcriberReq = true;
          this._updatesubscriberinfo.guaranT_CITY = this.getSubscriberDetails.guaranT_CITY;
          this._updatesubscriberinfo.guaranT_LNAME = this.getSubscriberDetails.guaranT_LNAME;
          this._updatesubscriberinfo.guaranT_FNAME = this.getSubscriberDetails.guaranT_FNAME;
          this._updatesubscriberinfo.guaranT_MI = this.getSubscriberDetails.guaranT_MI;
          this._updatesubscriberinfo.guaranT_ADDRESS = this.getSubscriberDetails.guaranT_ADDRESS;
          this._updatesubscriberinfo.guaranT_STATE = this.getSubscriberDetails.guaranT_STATE;
          this._updatesubscriberinfo.guarant_zip = this.getSubscriberDetails.guaranT_ZIP;
          this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this.getSubscriberDetails.guaranT_DOB, 'MM/dd/yyyy');
          this._updatesubscriberinfo.guaranT_SSN = this.getSubscriberDetails.guaranT_SSN;
          this._updatesubscriberinfo.guaranT_GENDER = this.getSubscriberDetails.guaranT_GENDER;
          this._updatesubscriberinfo.guaranT_HOME_PHONE = this.getSubscriberDetails.guaranT_HOME_PHONE;
          this._updatesubscriberinfo.guaranT_WORK_PHONE = this.getSubscriberDetails.guaranT_WORK_PHONE;
          this._updatesubscriberinfo.guaranT_WORK_PHONE_EXT = this.getSubscriberDetails.guaranT_WORK_PHONE_EXT;
          this._updatesubscriberinfo.guarantoR_CODE = this.getSubscriberDetails.guarantoR_CODE;
          this._updatesubscriberinfo.GUARANT_PRACTICE_CODE = this.getSubscriberDetails.guarant_practice_code;
          this._updatesubscriberinfo.GUARANT_TYPE = this.getSubscriberDetails.guarant_Type;
        }
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
    else {
      this.spinner.hide();
    }
  }
  editSubscriber() {
    $('#Insurance-Modal').modal('hide');
    $('#Subscriber-Modal').modal('show');
    this.translateService.get('button.update').subscribe((translation: string) => {
      this.subSAction = translation;
    });
    //this.subSAction ="Update";
    this.onFocusOutZIPSubsciber(this._updatesubscriberinfo.guarant_zip, 1);
    this._updatesubscriberinfo.guarant_dob = this.datepipe.transform(this._updatesubscriberinfo.guarant_dob, 'yyyy-MM-dd');
  }
  deleteSubscriber() {
    this._updatesubscriberinfo = new UpdateSubscriberInfo();
    this.isShowSubscriberForm = true;
    this.ResetSubscriberData();
    this._addpatientinsurancemodel.subscriber = '';
    let text = "Subscriber deleted successfully";
    this.translateService.get('Alerts.subscriber_deleted').subscribe((translation: string) => {
      text = translation;
    });
    this._phrutilService.showSuccess(text);
    //this._phrutilService.showSuccess("Subscriber deleted successfully");
  }
  backClick() {
    this.router.navigateByUrl('/pay_type');
  }

  nextClick() {
    if (this.landFromCheckin == 'drsite') {
      this.router.navigateByUrl("/appoin-mes");
    }
    else {
      localStorage.setItem("backFromCovid", "false");
      this.router.navigateByUrl('patient/intake');
    }
  }

  Next() {
    console.log("front and back");
    // console.log(this.fileObjFront, this.fileObjBack)
    if (this.fileObjFront || this.fileObjBack) {
      this.AddinsurancePhoto();
    } else if (this._addpatientinsurancemodel.insuranceId) {
      this.Add_Insurance_Info_confirmation_model();
    }
    else {
      this.nextClick();
    }
  }

  fileArray = Array();
  fileObjFront: any;
  fileObjBack: any;
  onChangeFileFront(event: any) {

    this.fileObjFront = event.target.files[0];
    if (this.fileObjFront) {
      this.showPreview(event, 'front');
      this.isRequireFrontCard = false;
      event.target.value = '';
      this.scrollToBackInput();
    }
    else {
      this.isRequireFrontCard = true;
      return;
    }
  }
  onChangeFileBack(event: any) {

    this.fileObjBack = event.target.files[0];
    if (this.fileObjBack) {
      this.showPreview(event, 'back');
      this.isRequireBackCard = false;
      event.target.value = '';
    }
    else {
      this.isRequireBackCard = true;
      return;
    }
  }
  scrollToBackInput(): void {
    console.log("backFileElement", this.fileBackInput);
    if (this.fileBackInput) {
      this.fileBackInput.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  isRequireFrontCard: any = false;
  isRequireBackCard: any = false;
  callOCRinsuranceService() {
    if (this.fileObjFront) {
      this.isRequireFrontCard = false;
      this.fileArray.push(this.fileObjFront);
    }
    else {
      this.isRequireFrontCard = true;
      this.scrollTobuttomandTop(true);
      return;
    }
    if (this.fileObjBack) {
      this.isRequireBackCard = false;
      this.fileArray.push(this.fileObjBack);
    }
    else {
      this.scrollTobuttomandTop(false);
      this.isRequireBackCard = true;
      return;
    }
    this.spinner.show();
    this._insuranceservice.OcrInsurance(this.fileArray).subscribe((res: any) => {
      this.spinner.hide();
      $("#Captured-Modal").modal("hide");
      if (res && res["Insurance Name"] && res["Insurance Name"].length > 0 && (this.insuranceDescriptionOCR.toLowerCase().includes(res["Insurance Name"].toLowerCase()) || this.searchinsurancemodel.insuranceName.toLowerCase().includes(res["Insurance Name"].toLowerCase()))) {
        this.OcrResponce = res;
        this._addpatientinsurancemodel.policyNumber = this.OcrResponce['Insurance ID'];
        this._addpatientinsurancemodel.groupId = this.OcrResponce['Group Number'].length > 0 ? this.OcrResponce['Group Number'] : this._addpatientinsurancemodel.groupId;
        this.isNotOCRinsurance = true;
        if (this._addpatientinsurancemodel.groupId !== "undefined" && this._addpatientinsurancemodel.groupId !== '') {
          this.HideVerifyDetail = true;
        }
        //$("#Insurance-Modal").modal("show");
      }
      else {
        //$("#incorrectinfoocr-model").modal("show");
      }
      this.fileArray = Array();
      this.defaultImagefront = 'assets/images/card-front.png';
      this.defaultImageback = 'assets/images/card-back.png';

    }, (error: any) => {

      this.spinner.hide();
      this.fileArray = Array();
      this.defaultImagefront = 'assets/images/card-front.png';
      this.defaultImageback = 'assets/images/card-back.png';
      $("#Captured-Modal").modal("hide");
      $("#incorrectinfoocr-model").modal("show");
    })

  }
  add_insurance_manual() {
    this.HideVerifyDetail = false;
    if (!this._addpatientinsurancemodel.insuranceId && !this.UpdateInsuranceModel.insuranceId) {
      this.insuranceNameError = true;
      return false;
    }
    else {
      this.insuranceNameError = false;
    }
    if (this.insuranceDescriptionOCR.toLowerCase().includes("medicare") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('medicare') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("cigna") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('cigna') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("aetna medicare") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('aetna medicare') ||
      this.insuranceDescriptionOCR.toLowerCase().includes("railroad") || this.searchinsurancemodel.insuranceName.toLowerCase().includes('railroad')) {
      if (this.insuranceNamePopup.length > 2) {
        //$("#Captured-Modal").modal("show");
        $("#Insurance-Modal").modal("hide");

      }
      else {
        //$("#Captured-Modal").modal("show");
      }
    }
    else {
      //show insurance card when the OCR is not exit for this insurance
      this.isNotOCRinsurance = true;
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.insurancetype = translation;
      });
      //this.insurancetype = "Add";
      this._addpatientinsurancemodel.relationship = 'S';
      //$('#Insurance-Modal').modal('show');
    }
    return true;
  }
  addInsuranceManullay() {
    $("#Captured-Modal").modal("hide");
    //$("#Insurance-Modal").modal("show");
    this.addInsurance = true;
    //this.addInsuranceManuallyNew();
    this.InsuranceDetails = false;

    if (this.insName_Id == '5001996') {
      $('#dd-rel').val('S').trigger("change");
      this._addpatientinsurancemodel.relationship = 'S';
    }
    else {
      $('#dd-rel').val('').trigger("change");
    }
    const insurancetype = localStorage.getItem("itype")
    console.log("istype " + insurancetype);
    this.isNotOCRinsurance = true;
    //if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'O') || insurancetype === 'Other') {

    //  this.insurancecat = 'P';

    //} else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'S') || insurancetype === 'Secondary') {

    //  this.insurancecat = 'O';

    //} else if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === 'P') || insurancetype === 'Primary') {

    //  this.insurancecat = 'S';

    //} else {

    //  this.insurancecat = 'P';

    //}
  }
  showCaptureModel() {
    //$("#Captured-Modal").modal("show");
  }
  closeCaptureCard(type: any) {
    if (type == 'close')
      //$("#Insurance-Modal").modal("show");
      this.fileArray = Array();
    this.fileObjFront = "";
    this.fileObjBack = "";
    this.isRequireFrontCard = false;
    this.isRequireBackCard = false;
  }

  showPop(element: any) {
    this.isPopup = !this.isPopup;
    $('#pop' + element).toggleClass('d-none');

  }
  selfpay: boolean = false;
  selfPay() {
    if ($('#selfPayCheckbox').prop("checked")) {
      this.selfpay = true;
    }
    else {
      this.selfpay = false;
    }

  }
  _deletepatientinsurance: DeleteInsuranceModel = new DeleteInsuranceModel();
  OpendeleteModel(insurance: any) {
    if (insurance.insurancE_ID != "" && insurance.insurancE_ID != undefined) {
      this._deletepatientinsurance.modifiedBy = this.PatientAccount;
      this._deletepatientinsurance.insuranceId = insurance.insurancE_ID;
      this._deletepatientinsurance.patientAccount = this.PatientAccount;
      this._deletepatientinsurance.practiceCode = this.PracticeCode;
      $('#insurancedeletemodel').modal('show');
    }
    else {
      let text = "Please select record first";
      this.translateService.get('Alerts.insurance_select_record_first').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showWarning(text);
      // this._phrutilService.showWarning("Please select record first");
    }
  }
  DeleteInsurance() {
    this.spinner.show();
    this._insuranceservice.DeletePatientInsurance(this._deletepatientinsurance).subscribe((res: any) => {
      $('#insurancedeletemodel').modal('hide');
      this.spinner.hide();
      if (res.statusCode == 200) {
        this.GetPatientInsuranceInfo(this.PatientAccount, this.PracticeCode, this.appointmentId);
        let text = "Insurance deleted successfully";
        this.translateService.get('Alerts.insurance_deleted').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Insurance deleted successfully");
      }
      else
        if (res.stateCode == 400) {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
    },
      (error: any) => {
        $('#insurancedeletemodel').modal('hide');
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }
  scrollTobuttomandTop(isScrollTop: any): void {
    try {
      if (isScrollTop) {
        this.myScrollContainer.nativeElement.scrollTop = '0';
      }
      else if (!isScrollTop) {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight
      }
    } catch (err) { }
  }
  //show local image
  //showPreview(event: Event, type: any) {
  //  let selectedFile = (event.target as HTMLInputElement).files!.item(0)
  //  if (selectedFile) {
  //    if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
  //      let fileReader = new FileReader();
  //      fileReader.readAsDataURL(selectedFile);

  //      fileReader.addEventListener('load', (event) => {
  //        if (type == 'front')
  //          this.defaultImagefront = event.target?.result;
  //        else if (type == 'back')
  //          this.defaultImageback = event.target?.result;
  //      })
  //    }
  //  }
  //}
  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);

        fileReader.addEventListener('load', (event) => {
          if (type == 'front') {
            console.log("front");
            this.isFrontPhotoUpload = true;
            this.defaultImagefront = event.target?.result;
          }

          else if (type == 'back') {
            console.log("back");
            this.isbackPhotoUpload = true;
            this.defaultImageback = event.target?.result;
          }
        })
      }
    }
  }
  checkValidDate(selecteddata: any) {
    this._updatesubscriberinfo.guarant_dob = this._phrutilService.CheckValidDateAndSetDefaultDateGlobal(selecteddata.target.value);
  }
  isDateError: boolean = false;
  onChangeDate(selecteddata: any) {
    this.isDateError = this._phrutilService.CheckDateLessThenCurretDateGlobal(selecteddata.target.value);
  }
  selectInsurance(event: any) {

    const option = (event.target as HTMLSelectElement)?.value;
    if (option) {
      this.insurancecat = option;
      if (!this.insurancemodel) {
        this.ClickInsuranceInfo(option, true);
      }
      if (this._insurances.some(res => res.prI_SEC_OTH_TYPE === option)) {
        if (option === 'P' && this.isPrimaryInsuranceInactive == false) {
          let text = "You can only add one primary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_primary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);

        } else if (option === 'S') {
          let text = "You can only add one secondary insurance";
          this.translateService.get('Alerts.insurance_only_add_one_secondary').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);;
        } else if (option === 'O') {
          let text = "You Can Only Add One Other Insurance";
          this.translateService.get('Alerts.insurance_only_add_one_other').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showInfo(text);
        }
        return true;
      }
    }
    return true;
  }
}
